import _ from 'lodash';
import palette from 'google-palette';
import moment from 'moment';
import React from 'react';
import { Line } from 'react-chartjs-2';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { isMobileBrowser } from '../../utils/utilsFunctions';

const ScrollableLineChart = (props) => {
  const { data, labels, stepSize, max, min, legend, chartPalette, yAxeTitle, xAxeTitle } = props;

  const options = {
    animation: false,
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: legend,
      position: 'bottom'
    },
    tooltips: {
      callbacks: {
        title: function (tooltipItems) {
          const label = tooltipItems[0].xLabel || '';
          return moment(label).format('L');
        }
      }
    },
    scales: {
      yAxes: [
        {
          ticks: {
            max,
            min,
            stepSize
          },
          scaleLabel: {
            display: yAxeTitle,
            labelString: yAxeTitle
          }
        }
      ],
      xAxes: [
        {
          ticks: {
            maxRotation: 90,
            minRotation: 0,
            callback: function (value, index, values) {
              return moment(value).format('L');
            }
          },
          scaleLabel: {
            display: xAxeTitle,
            labelString: xAxeTitle
          }
        }
      ]
    }
  };

  const paletteColors = chartPalette ? chartPalette : palette('mpn65', _.size(data));
  const chart = {
    labels,
    datasets: _.map(data, (set, index) => ({
      data: set.values,
      fill: false,
      label: set.label,
      borderDash: !paletteColors ? [5, 5] : [1, 0],
      borderColor: paletteColors ? `#${paletteColors[index]}` : null
    }))
  };

  const dataSetSize = data && data[0] && data[0].values ? data[0].values.length : 0;
  let maxWidth = window.screen.width - 280 - 80;
  maxWidth = isMobileBrowser() ? window.screen.width + 100 : maxWidth;

  const minPointWidth = 20;
  const calculatedWidth = dataSetSize * minPointWidth;
  let chartWidth = maxWidth;
  if (calculatedWidth < maxWidth) {
    chartWidth = maxWidth;
  } else {
    chartWidth = calculatedWidth;
  }

  return (
    <div className="chartWrapper">
      <PerfectScrollbar style={{ paddingBottom: 15 }}>
        <div className="chartAreaWrapper" style={{ width: chartWidth, height: 500 }}>
          <Line key={chartWidth} data={chart} options={options} />
        </div>
      </PerfectScrollbar>
    </div>
  );
};

export default ScrollableLineChart;
